<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <div class="row">
        <div class="col-md-12">
          <base-button type="success" size="sm" @click="irnuevo">
            <i class="fa fa-plus fa-fw"></i> Nuevo
          </base-button>
        </div>
      </div>
      <b-card-header header-tag="header" class="p-1" role="tab" style="margin-top: 30px">Filtros</b-card-header>
      <b-card-body>
        <div class="row" style="margin-top: 10px">
          <div class="col-md-6">
            <label>Fecha desde</label>
            <br />
            <KitsDateTime v-model="model.desde" :currentValue="model.desde" />
          </div>
          <div class="col-md-6">
            <label>Fecha hasta</label>
            <br />
            <KitsDateTime v-model="model.hasta" :currentValue="model.hasta" />
          </div>
          <div class="col-md-6">
            <label>Estado</label>
            <br />
            <KitsCombo
              v-model="model.estado"
              v-bind:items="estados"
              propertyName="Name"
              propertyID="EntityID"
              todos="true"
            ></KitsCombo>
          </div>
          <div class="col-md-6">
            <label>Banco</label>
            <br />
            <KitsCombo
              v-model="model.banco"
              v-bind:items="bancos"
              propertyName="Display"
              propertyID="EntityID"
              todos="true"
            ></KitsCombo>
          </div>
        </div>
        <div class="row" style="margin-top: 10px">
          <div class="col-md-12 text-right">
            <filter-button @click="filtrar"></filter-button>
          </div>
        </div>
      </b-card-body>
    </b-card>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Solicitudes</b-card-header>
      <b-card-body>
        <div class="row" style="margin-top: 10px">
          <div class="col-md-12">
            <download-csv
              v-if="movimientos.length > 0"
              class="btn btn-success"
              :data="movimientos"
              :fields="csv.json_fields"
              :labels="csv.labels"
              :name="exportFileName"
              delimiter=";"
            >
              <i class="fa fa-fw fa-file-excel"></i>
              Exportar
            </download-csv>
            <b-table striped hover :items="movimientos" :fields="campos" class="mt-3" outlined>
              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Cargando...</strong>
              </div>
            </b-table>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<style>
</style>

<script>
// ******************** Select ********************//
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
// ******************** Select ********************//

import axiosHelpers from "@/helpers/axiosHelpers";
import datetimeHelpers from "@/helpers/datetimeHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";

import KitsCombo from "@/components/KitsCombo";
import KitsDateTime from "@/components/KitsDateTime";

import DateTime from "luxon/src/datetime.js";

import JsonCSV from "vue-json-csv";
Vue.component("downloadCsv", JsonCSV);

export default {
  components: { KitsCombo, KitsDateTime },
  data() {
    return {
      procesando: false,
      nombrearchivo: "Mis Pagos Recibidos.csv",
      movimientos: [],
      campos: [
        {
          key: "FormatedAmount",
          label: "Importe",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "FormatedDate",
          label: "Fecha",
          sortable: true,
          sortDirection: "desc"
        },
        { key: "Bank", label: "Banco", sortable: true, sortDirection: "desc" },
        { key: "CBU", label: "CBU", sortable: true, sortDirection: "desc" },
        { key: "State", label: "Estado", sortable: true, sortDirection: "desc" }
      ],
      estados: [],
      bancos: [],
      model: {
        desde: null,
        hasta: null,
        estado: null,
        banco: null
      },
      csv: {
        json_fields: ["FormatedAmount", "FormatedDate", "Bank", "CBU", "State"],
        labels: {
          FormatedAmount: "Importe",
          FormatedDate: "Fecha",
          Bank: "Banco",
          CBU: "CBU",
          State: "Estado"
        },
        json_meta: [
          [
            {
              key: "charset",
              value: "utf-8"
            }
          ]
        ]
      }
    };
  },
  computed: {
    // a computed getter
    exportFileName: function() {
      var d = new Date();
      var datestring = datetimeHelpers.getFormattedDDMMYYYY(d, "");
      var temp = "Mis Transferencias" + datestring + ".csv";

      return temp;
    }
  },
  methods: {
    filtrar() {
      if (datetimeHelpers.compareFromTo(this.model.desde, this.model.hasta)) {
        notificationHelpers.showWarning(
          "Advertencia!",
          "La fecha hasta debe ser superior a la fecha desde",
          this
        );
        return;
      }

      if (
        datetimeHelpers.compareDifference(
          this.model.desde,
          this.model.hasta,
          62
        )
      ) {
        notificationHelpers.showWarning(
          "Advertencia!",
          "El rango de fechas ingresado no puede superar los 2 meses",
          this
        );
        return;
      }

      let req = {
        DateFrom: this.model.desde,
        DateTo: this.model.hasta,
        StateID: this.model.estado,
        SupplierBankAccountID: this.model.banco
      };

      let context = this;

      axiosHelpers.axiosGet("Supplier/GetSupplierTransfer", req, this, function(
        data
      ) {
        context.movimientos = data.ResponseVM;
      });

      console.log(req);
    },
    irnuevo() {
      this.$router.push({ name: "nuevatransferencia" });
    }
  },
  beforeMount: function() {
    let context = this;

    this.desde = datetimeHelpers.getMonthStart();
    this.hasta = datetimeHelpers.getNextDay();

    axiosHelpers.axiosGet(
      "Supplier/GetTransferRequestStates",
      {},
      this,
      function(data) {
        context.estados = data.ResponseVM;
      }
    );

    axiosHelpers.axiosPost(
      "Supplier/GetSupplierBankAccountList",
      {},
      this,
      function(data) {
        context.bancos = data.ResponseVM;
      }
    );
  }
};
</script>